module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block block-link-shadow text-center"
  }, [_c('div', {
    staticClass: "block-content block-content-full block-sticky-options pt-30"
  }, [_c('div', {
    staticClass: "block-options"
  }, [_c('b-dropdown', {
    staticClass: "dropdown-no-btn",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-v"
  })]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.openProductsTable
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Producten\n          ")])], 2)], 1), _vm._v(" "), _c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": '/static/img/dropshipment/' + _vm.vendor.type + '.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('div', {
    staticClass: "font-w600 mb-5"
  }, [_vm._v(_vm._s(_vm.vendor.name))]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v(_vm._s(_vm.products.total) + " producten in koppeling")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push text-center"
  }, [(_vm.vendor.sync_interval === 'daily') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Synchroniseert dagelijks om " + _vm._s(_vm.vendor.sync_time))])])]) : _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Synchronisatie n.v.t.")])])])])]), _vm._v(" "), (_vm.showProductsTable) ? _c('dropshipment-products-table', {
    attrs: {
      "vendor": _vm.vendor
    },
    on: {
      "close": function($event) {
        _vm.showProductsTable = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c77f514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dropshipment/DropshipmentWidget.vue
// module id = 755
// module chunks = 1